document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.properties .property').forEach((property) => {
		const gallery = property.querySelector('.gallery')
		if (!gallery) return

		const sliderEl = gallery.querySelector('.keen-slider')
		const prevBtn = gallery.querySelector('.prev')
		const nextBtn = gallery.querySelector('.next')
		const dots = gallery.querySelectorAll('button.dot')

		new KeenSlider(
			sliderEl,
			{
				loop: true,
				slides: {
					perView: 1,
				},
			},
			[
				(slider) => {
					function updateClasses() {
						let slide = slider.track.details.rel
						dots.forEach((dot) => {
							dot.classList.remove('active')
						})
						dots[slide].classList.add('active')
					}

					prevBtn.addEventListener('click', () => slider.prev())
					nextBtn.addEventListener('click', () => slider.next())

					dots.forEach((dot) => {
						dot.addEventListener('click', () => {
							let targetIndex = parseInt(dot.dataset.index)
							slider.moveToIdx(targetIndex)
						})
					})

					slider.on('slideChanged', () => {
						updateClasses()
					})
				},
			]
		)
	})
})
